import type { ReactElement, ReactNode } from "react";
import css from "../record.module.css";

export interface RecordPageFrameProps {
  children: ReactNode;
}

export default function RecordPageFrame({ children }: RecordPageFrameProps): ReactElement {
  return (
    <main id="main-content" tabIndex={-1} data-testid="record-page-frame" className={css.pageFrame}>
      {children}
    </main>
  );
}
